import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthLayout } from '@/layouts/AuthLayout';
import { ProtectedRoute } from '@/components/common/ProtectedRoute';

import { NotFoundPage } from '@/pages/NotFoundPage';
import GameLayout from './layouts/GameLayout';
import MainLayout from './layouts/MainLayout';
import {
  AccountStatementPage,
  ActivityLogsPage,
  AuthVerificationPage,
  CasinoResultsPage,
  ChangePasswordPage,
  BetHistoryPage,
  HomePage,
  LiveCasinoBetsPage,
  LoginPage,
  MarketsPage,
  SportsPage,
  TermsConditionsPage,
  CasinoPage,
  QTECHLobbyPage,
  CasinoPlaygroundPage,
  CasinoBetHistoryPage,
  DepositPage,
  WithdrawPage,
} from '@/routes';
import { ScrollToTop } from '@/utils/ScrollToTop';
import CasinoLayout from './layouts/CasinoLayout';
import ResponsibleGaming from './pages/ResponsibleGaming';

export function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Auth Routes */}
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<LoginPage />} />
        </Route>
        <Route element={<MainLayout />}>
          <Route path="/" element={<Navigate to="/home" replace />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/all-sports/:sportName" element={<SportsPage />} />
          <Route path="/user/account-statement" element={<AccountStatementPage />} />
          <Route path="/user/bet-history" element={<BetHistoryPage />} />
          <Route path="/user/activity-logs" element={<ActivityLogsPage />} />
          {/* <Route path="/user/casino-results" element={<CasinoResultsPage />} /> */}
          {/* <Route path="/user/live-casino-bets" element={<LiveCasinoBetsPage />} /> */}
          <Route path="/user/casino-bet-history" element={<CasinoBetHistoryPage />} />
          <Route path="/user/secure-auth-verification" element={<AuthVerificationPage />} />
          <Route path="/user/change-password" element={<ChangePasswordPage />} />
          <Route path="/deposit" element={<DepositPage />} />
          <Route path="/withdraw" element={<WithdrawPage />} />
        </Route>
        <Route element={<CasinoLayout />}>
          <Route path="/casino/" element={<CasinoPage />} />
          <Route path="/casino-playground" element={<CasinoPlaygroundPage />} />
          <Route path="/casino/:provider/:category?" element={<CasinoPage />} />
          <Route path="/casino-qtech" element={<QTECHLobbyPage />} />
        </Route>
        <Route element={<GameLayout />}>
          <Route path="/game-details/:sportName/:eventId" element={<MarketsPage />} />
        </Route>

        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}></Route>

        {/* 404 */}
        <Route path="/terms-and-conditions" element={<TermsConditionsPage />} />
        <Route path="/responsible-gaming" element={<ResponsibleGaming />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}
